import React, { Component } from "react";

import { Typography } from "@mui/material";

import { HStack, Spacer, VStack } from "Components/LabIZO/Stackizo";
import { Accessor } from "static";

class Denied extends Component {
  static propTypes = {};

  static defaultProps = {};

  componentDidMount() {
    this.setState((state, props) => ({
      ...props,
    }));
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(Denied.defaultProps))) {
      this.componentDidMount();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  render() {
    return (
      <VStack gap={15}>
        <Spacer />
        <HStack width="15vw">
          <img src={`${process.env.PUBLIC_URL}/Images/denied.svg`} alt="not-found" style={{ width: "100%" }} />
        </HStack>
        <Typography style={{ fontSize: 20, fontWeight: "bold" }}>{"Access Denied"}</Typography>
        <Spacer />
      </VStack>
    );
  }
}

export default Denied;
